<template>
  <div class="content if-profile customize_report report-tab">
    <div class="md-layout profit-loss">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0"
      >
        <VRHeader :headerData="this.headerData" :checkData="checked" />
      </div>
      <div class="content-checkbox mt-4">
        <div
          class="md-layout-item md-medium-size-100 md-size-100 md-large-size-100 p-0 mt-4"
        >
          <h1 class="section_header">Customize Report</h1>
          <nav-tabs-card>
            <md-tabs md-alignment="left">
              <md-tab
                id="content-years"
                md-label="Check to Integrate Content Years"
                md-icon="arrow_drop_down"
                class="p-0"
              >
                <div class="md-layout">
                  <div class="md-layout-item p-0">
                    <md-card-header
                      >Check to Integrate Content Years</md-card-header
                    >
                    <md-card-content>
                      <div class="md-layout">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 p-0"
                        >
                          <div class="full-control">
                            <ul class="md-layout checkbox-customize p-0 m-0">
                              <md-list-item
                                v-for="(year, index) in this.vestimateReport
                                  .years"
                                :key="index"
                                class="configure-card-1 checkbox-costomiz md-layout-item md-size-50"
                              >
                                <md-checkbox
                                  v-model="checked"
                                  :value="'year_' + index"
                                />
                                <span class="md-list-item-text">{{
                                  year
                                }}</span>
                              </md-list-item>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </md-card-content>
                  </div>
                </div>
                <div
                  v-if="!isSample"
                  @click="saveReport()"
                  class="md-layout-item md-size-100 contact-submit submit-box p-0"
                >
                  <md-button
                    :md-ripple="false"
                    class="md-info md-block access-button bottom-check"
                    >Submit</md-button
                  >
                </div>
              </md-tab>
              <md-tab
                id="market-kpis"
                md-label="Check to Integrate Financial and Market KPIs"
                md-icon="arrow_drop_down"
                class="p-0"
              >
                <div class="md-layout">
                  <div class="md-layout-item p-0">
                    <md-card-header
                      >Check to Integrate Financial and Market
                      KPIs</md-card-header
                    >
                    <md-card-content>
                      <div class="md-layout">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-50 p-0"
                        >
                          <div
                            v-for="(ratio, index) in leftRatioOutput"
                            :key="index + 'left'"
                          >
                            <div
                              v-if="ratio.checkbox"
                              class="checkbox-costomiz md-size-100 px-4"
                            >
                              <md-list-item class="md-size-40 m-0">
                                <md-checkbox
                                  v-model="checked"
                                  :value="ratio.id"
                                />
                                <span class="md-list-item-text">{{
                                  ratio.title
                                }}</span>
                              </md-list-item>
                            </div>

                            <div
                              v-else-if="ratio.title"
                              class="md-size-100 sub_title"
                            >
                              {{ ratio.title }}
                            </div>

                            <div v-else class="checkbox-costomiz md-size-100">
                              <md-list-item class="md-size-40"></md-list-item>
                            </div>
                          </div>
                        </div>
                        <div
                          class="md-layout-item md-medium-size-100 md-size-50 p-0"
                        >
                          <div
                            v-for="(ratio, index) in rightRatioOutput"
                            :key="index + 'right'"
                          >
                            <div
                              v-if="ratio.checkbox"
                              class="checkbox-costomiz md-size-100 px-4"
                            >
                              <md-list-item class="md-size-40 m-0">
                                <md-checkbox
                                  v-model="checked"
                                  :value="ratio.id"
                                />
                                <span class="md-list-item-text">{{
                                  ratio.title
                                }}</span>
                              </md-list-item>
                            </div>

                            <div
                              v-else-if="ratio.title"
                              class="md-size-40 sub_title"
                            >
                              {{ ratio.title }}
                            </div>

                            <div v-else class="checkbox-customize md-size-100">
                              <md-list-item class="md-size-40"></md-list-item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </md-card-content>
                  </div>
                </div>
                <div
                  v-if="!isSample"
                  @click="saveReport()"
                  class="md-layout-item md-size-100 contact-submit submit-box p-0"
                >
                  <md-button
                    :md-ripple="false"
                    class="md-info md-block access-button bottom-check"
                    >Submit</md-button
                  >
                </div>
              </md-tab>
              <md-tab
                id="value-indicators"
                md-label="Check to Integrate Other Value Indicators"
                md-icon="arrow_drop_down"
                class="p-0"
              >
                <div class="md-layout">
                  <div class="md-layout-item p-0">
                    <md-card-header
                      >Check to Integrate Other Value Indicators</md-card-header
                    >
                    <md-card-content>
                      <div class="configure-card-1 px-4">
                        <div class="md-size-50 configure-card-1 px-4">
                          <md-checkbox v-model="check_key_employees" />
                          <span class="md-list-item-text">Key Employees</span>
                        </div>
                        <div class="md-button-content px-4">
                          <template>
                            <input
                              aria-label="range"
                              type="range"
                              min="0"
                              max="10"
                              step="0.25"
                              v-model="slider_key_employees"
                            />
                            {{ slider_key_employees }}
                          </template>
                        </div>
                      </div>
                      <p class="sub_para">
                        Assess the age, loyalty, training, experience and
                        motivation of the workforce. Low= &#10094;5; High=>5
                      </p>
                      <div class="configure-card-1 px-4">
                        <div class="md-size-30 configure-card-1 px-4">
                          <md-checkbox v-model="check_customer_base" />
                          <span class="md-list-item-text">Customer Base</span>
                        </div>
                        <div class="md-button-content px-4">
                          <template>
                            <input
                              aria-label="range"
                              type="range"
                              min="0"
                              max="10"
                              step="0.25"
                              v-model="slider_customer_base"
                            />
                            {{ slider_customer_base }}
                          </template>
                        </div>
                      </div>
                      <p class="sub_para">
                        Is customer stability seasonal with low repeat sales
                        (&#10094;5) or year round with high repeat levels (>5)?
                      </p>
                      <div class="configure-card-1 px-4">
                        <div class="md-size-30 configure-card-1 px-4">
                          <md-checkbox v-model="check_technology_level" />
                          <span class="md-list-item-text"
                            >Technology Level</span
                          >
                        </div>
                        <div class="md-button-content px-4">
                          <template>
                            <input
                              aria-label="range"
                              type="range"
                              min="0"
                              max="10"
                              step="0.25"
                              v-model="slider_technology_level"
                            />
                            {{ slider_technology_level }}
                          </template>
                        </div>
                      </div>
                      <p class="sub_para">
                        Are technology practices up to date? How do they compare
                        with competitors? Low= &#10094;5; High=>5
                      </p>
                      <div class="configure-card-1 px-4">
                        <div class="md-size-30 configure-card-1 px-4">
                          <md-checkbox v-model="check_customer_concentration" />
                          <span class="md-list-item-text"
                            >Customer Concentration</span
                          >
                        </div>
                        <div class="form-group px-4">
                          <div class="text-switch yesno-switch mt-2">
                            <input
                              aria-label="checkbox"
                              type="checkbox"
                              name
                              id="check3"
                              v-model="customer_concentration"
                              class="text-switch-check"
                            />
                            <label for="check3" class="text-switch-label">
                              <span class="text-swtch-data">
                                <span class="left">Yes</span>
                                <span class="dot-circle"></span>
                                <span class="right">No</span>
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <p class="sub_para">
                        Do the top 5 customers account for >25% of revenue; or
                        does any one customer account for >10%?
                      </p>
                    </md-card-content>
                  </div>
                </div>
                <div
                  @click="saveReport()"
                  class="md-layout-item md-size-100 contact-submit submit-box p-0"
                >
                  <md-button
                    :md-ripple="false"
                    class="md-info md-block access-button bottom-check"
                    >Submit</md-button
                  >
                </div>
              </md-tab>
              <md-tab
                id="developer-client"
                md-label="Client Display (optional)"
                md-icon="arrow_drop_down"
                class="p-0"
              >
                <div class="md-layout">
                  <div class="md-layout-item p-0">
                    <md-card-header>Client Display (optional)</md-card-header>
                    <md-card-content>
                      <div class="md-layout contact-form">
                        <div class="md-layout-item md-size-100 p-0">
                          <div class="md-layout d-flex">
                            <div class="md-layout-item">
                              <md-field class="label m-0">
                                <label for="first-name">Company Name:</label>
                              </md-field>
                            </div>
                            <div class="md-layout-item">
                              <md-field class="input m-0">
                                <md-input
                                  class="form-input"
                                  v-model="client_name"
                                  placeholder="Main Street Plumbing"
                                ></md-input>
                              </md-field>
                            </div>
                          </div>
                          <div v-if="false" class="md-layout">
                            <div class="md-layout-item choose-img-box">
                              <div class="label_wpr">
                                <label for="first-name">Company Logo:</label>
                                <div
                                  v-if="client_logo"
                                  class="md-layout-item md-size-65"
                                >
                                  <md-field class="label m-0">
                                    <div>
                                      <img :src="client_logo" alt="Avatar" />
                                      <md-button
                                        :md-ripple="false"
                                        @click="removeImage(client_logo)"
                                        class="md-info md-block access-button bottom-check md-dense mt-4 mb-4"
                                        >Remove</md-button
                                      >
                                    </div>
                                  </md-field>
                                </div>
                              </div>
                            </div>
                            <div class="md-layout-item">
                              <div class="choose-files-box">
                                <md-field class="choose-file">
                                  <label>Choose File</label>
                                  <md-file
                                    v-model="client_logo"
                                    accept="image/*"
                                    @change="onClientChange"
                                  />
                                </md-field>
                                <p>No Choose file</p>
                              </div>
                              <p>
                                (maximum dimensions of 800px x 800px ): PNG,
                                JPG, JEPG, GIF
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </md-card-content>
                  </div>
                </div>
                <div
                  v-if="!isSample"
                  @click="saveReport()"
                  class="md-layout-item md-size-100 contact-submit submit-box p-0"
                >
                  <md-button
                    :md-ripple="false"
                    class="md-info md-block access-button bottom-check"
                    >Submit</md-button
                  >
                </div>
              </md-tab>
            </md-tabs>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VRHeader from "./_partials/VRHeader";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    VRHeader,
  },
  props: ["headerData"],
  data() {
    return {
      checked: [],
      amount: [],
      ringtone: "peace",
      boolean: true,
      loading: false,
      base: process.env.VUE_APP_API_BASE_URL + "/IFBB_Images/",
      check_key_employees: false,
      check_customer_base: false,
      check_technology_level: false,
      check_customer_concentration: false,
      check_customer_concentration_sent: "off",
      slider_key_employees: 0,
      slider_customer_base: 0,
      slider_technology_level: 0,
      customer_concentration: "off",
      client_name: "",
      developer_name: null,
      developer_phone: null,
      developer_email: null,
      developer_logo: null,
      developer_file: null,
      client_logo: null,
      client_file: null,
      currentData: [],
      inputData: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      client: (state) => state.user.vestimate_report.data.developerClient,
      vestimateReport: (state) => state.user.vestimate_report.data,
      naics: (state) => state.user.vestimate_report.data.IMRnaics,
      industryName: (state) => state.user.vestimate_report.data.IMRindustry,
      displayArea: (state) => state.user.vestimate_report.data.MR.area,
      reportDate: (state) => state.user.vestimate_report.data.report_date,
      companyName: (state) =>
        state.user.vestimate_report.data.input_structure["Company Name"][
          "value"
        ],

      inputFields: (state) => state.user.vestimate_report.data.inputFields,
      inputStructure: (state) =>
        state.user.vestimate_report.data.inputStructure,
      yearsAux: (state) => state.user.vestimate_report.data.years,
    }),
    years() {
      return this.yearsAux.map((item) => {
        if (!this.$route.path.includes("dev")) return item;

        return item - 1;
      });
    },
    leftRatioOutput() {
      return this.vestimateReport.ratioOutput.map((ratio) => ratio.left);
    },
    rightRatioOutput() {
      return this.vestimateReport.ratioOutput.map((ratio) => ratio.right);
    },
    isSample() {
      return this.$route.path.indexOf("sample") > -1;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions({
      save: "user/saveVestimateReport",
      alertSuccess: "alerts/success",
      alertError: "alerts/error",
      updatePullTime: "tracking/updatePullTime",
    }),
    init() {
      this.developer_name = this.vestimateReport.developerClient
        ? this.vestimateReport.developerClient.developer_name
        : "";
      this.developer_phone = this.vestimateReport.developerClient
        ? this.vestimateReport.developerClient.developer_phone
        : "";
      this.developer_email = this.vestimateReport.developerClient
        ? this.vestimateReport.developerClient.developer_email
        : "";
      this.developer_logo = this.vestimateReport.developerClient
        ? this.vestimateReport.developerClient.developer_logo
        : "";
      this.client_logo = this.vestimateReport.developerClient
        ? this.vestimateReport.developerClient.client_logo
        : "";
      this.client_name = this.vestimateReport.developerClient
        ? this.vestimateReport.developerClient.client_name
        : "";

      this.checked = Object.keys(this.vestimateReport.displaySettings).filter(
        (i) => i
      );
      this.checkUncheck(true);
      if (this.vestimateReport.sliderInputs.technology_level > 0) {
        this.check_technology_level = true;
        this.slider_technology_level = this.vestimateReport.sliderInputs.technology_level;
      }
      if (this.vestimateReport.sliderInputs.customer_base > 0) {
        this.check_customer_base = true;
        this.slider_customer_base = this.vestimateReport.sliderInputs.customer_base;
      }
      if (this.vestimateReport.sliderInputs.key_employees > 0) {
        this.check_key_employees = true;
        this.slider_key_employees = this.vestimateReport.sliderInputs.key_employees;
      }
      if (
        this.vestimateReport.sliderInputs.customer_concentration_check === 1
      ) {
        this.check_customer_concentration = true;
        this.check_customer_concentration_sent = "on";
      } else {
        this.check_customer_concentration = false;
        this.check_customer_concentration_sent = "off";
      }
      if (this.vestimateReport.sliderInputs.customer_concentration === 1) {
        this.customer_concentration = "on";
      }

      let IFInputs = this.vestimateReport.input_structure["IFInputs"];

      this.years.forEach((elem, index) => {
        let a = {};
        a.year = elem;
        this.inputFields.forEach((info, i) => {
          info.data.forEach((element, index) => {
            if (IFInputs[elem] && element in IFInputs[elem]) {
              a[element] = {};
              a[element].name = IFInputs[elem][element].field;
              a[element].value = IFInputs[elem][element].value;
              a[element].input = element;
            }
          });
        });
        this.inputData.push(a);
      });

      this.years.forEach((elem, index) => {
        let b = {};
        b.year = parseInt(this.years[index]) + 1;
        this.inputFields.forEach((info, i) => {
          info.data.forEach((element, index) => {
            if (IFInputs[elem] && element in IFInputs[elem]) {
              b[element] = IFInputs[elem][element]["value"];
            }
          });
        });
        this.currentData.push(b);
      });

      this.inputData = this.currentData.reduce(
        (acc, item, index) => ({
          ...acc,
          ...Object.entries(item).reduce(
            (acc, [key, val]) => ({
              ...acc,
              [key + index]: val,
            }),
            {}
          ),
        }),
        {}
      );
    },
    checkUncheck(isChecked) {
      this.vestimateReport.ratioOutput.forEach(({ left, right }) => {
        if (left.id || right.id) {
          if (isChecked) {
            if (left.id && left.checked) this.checked.push(left.id);
            if (right.id && right.checked) this.checked.push(right.id);
          } else {
            if (this.checked.includes(left.id))
              this.checked = this.checked.filter((i) => i !== left.id);
            if (this.checked.includes(right.id))
              this.checked = this.checked.filter((i) => i !== right.id);
          }
        }
      });
    },
    onClientChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.createClientImage(files[0]);
    },
    onDeveloperChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.createDeveloperImage(files[0]);
    },
    createClientImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.client_logo = e.target.result;
        this.client_file = file;
      };
      reader.readAsDataURL(file);
    },
    createDeveloperImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.developer_logo = e.target.result;
        this.developer_file = file;
      };
      reader.readAsDataURL(file);
    },
    removeImage(logo) {
      logo = null;
    },
    saveReport(action = "save", logo) {
      this.loading = true;
      let params = {};

      if (action === "save") {
        params = this.checked
          .filter((i) => i)
          .reduce(
            (acc, cur) => ({
              ...acc,
              [cur + "_check"]: true,
            }),
            {}
          );
        if (this.check_customer_concentration) {
          this.check_customer_concentration_sent = "on";
        } else {
          this.check_customer_concentration_sent = "off";
        }
        params.client_name = this.client_name;
        params.client_logo = this.client_logo;

        params.check_technology_level = this.check_technology_level || null;
        params.check_customer_base = this.check_customer_base || null;
        params.check_key_employees = this.check_key_employees || null;
        params.check_customer_concentration = this.check_customer_concentration_sent;

        params.slider_technology_level = this.slider_technology_level || null;
        params.slider_customer_base = this.slider_customer_base || null;
        params.slider_key_employees = this.slider_key_employees || null;
        params.customer_concentration = this.customer_concentration;
      }
      if (action === "remove") {
        params = logo;
      }
      this.save({
        report_id: this.$route.params.id,
        profile_id: this.$route.params.id,
        type: "valuation_main",
        action: action,
        ...this.inputData,
        ...params,
      })
        .then((res) => {
          this.alertSuccess("Data loaded.");

          this.$router.push({
            name: "VRAbouttheData",
            params: this.$route.params.id,
          });
          this.$router.go();
        })
        .catch((err) => {
          this.alertSuccess("Data loaded.");
        })
        .finally(() => {
          this.loading = false;
          this.updatePullTime({
            isFinishedDate: true,
            productId: this.$route.params.id,
          });
        });
    },
  },
};
</script>
<style lang="scss">
.content-checkbox {
  .contact-box {
    padding: 20px 0 0 20px !important;
  }

  .customize-report-year {
    color: #3b7ef1;

    .full-control {
      .md-list {
        max-width: 100%;
        height: 400px;
        display: inline-block;
        overflow: auto;
        border: 1px solid rgba(#000, 0.12);
        vertical-align: top;
      }
    }
  }

  .md-ripple {
    span {
      position: inherit !important;
      font-size: 0.9625rem;
      color: #3c4858;
      font-weight: 500;
    }

    .title-box {
      color: #3b7ef1;
    }
  }

  .check-all {
    border-top-color: #ddd !important;
  }

  .checkbox-costomiz {
    display: flex !important;
    justify-content: space-between !important;
    border-bottom: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
  }

  .bottom-check {
    background-color: #3b7ef1;
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    width: auto !important;
    margin-left: 10px;
  }

  .title-text {
    color: #3b7ef1;
  }

  .choose-files-box {
    display: flex;
    align-items: center;

    p {
      margin: 0 0 0 10px;
    }

    .choose-file {
      background-color: #e3e4e5 !important;
      width: 120px !important;
      border-radius: 3px;
      padding: 0 24px;
      margin: 0;
      align-items: center;

      label {
        margin-right: 11px;
        position: absolute;
        left: 24px;
        top: 9px;
      }

      i {
        display: none;
      }
    }
  }

  .md-collapse-content {
    padding: 0 !important;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }
}

.icon-choos-box {
  .md-icon {
    display: none !important;
  }
}

h4.main-street {
  padding-top: 0;
}

.financal-report-col-3 {
  display: flex;
  justify-content: flex-end;
}

.configure-card-1 {
  display: flex;
  justify-content: space-between;
  padding: 0;
  align-items: center;
}

.contact-submit {
  display: flex;
  justify-content: flex-end;
}

button:focus,
input:focus {
  outline: none;
  box-shadow: none;
}

a,
a:hover {
  text-decoration: none;
}

/*------------------  */
.text-switch {
  position: relative;
  display: inline-block;
  width: 48px;
  min-width: 48px;
}

.text-switch-check {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  visibility: hidden;
}

.text-switch-label {
  display: flex;
  align-items: center;
  overflow: hidden;
  background-color: #e3e5ef;
  border-radius: 3px;
  height: 28px;
  margin-bottom: 0;
  transition: 0.5s;
  position: relative;
  border-radius: 14px;
}

.text-switch-label .text-swtch-data {
  display: flex;
  align-items: center;
  position: absolute;
  height: 100%;
  left: -1px;
  transition: 0.5s;
}

.text-switch-label .dot-circle {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  border-radius: 12px;
  background-color: #fff;
  margin: 0px 3px;
}

.text-switch .text-switch-check:checked + .text-switch-label {
  background-color: #1c85e8;
}

.text-switch .text-switch-check:checked + .text-switch-label .text-swtch-data {
  left: 19px;
}

.text-swtch-data .left {
  color: #fff;
}

.text-swtch-data .right {
  color: #8a93a6;
}

.text-swtch-data .left,
.text-swtch-data .right {
  font-size: 12px;
  font-weight: 500;
  width: 49px;
  text-align: center;
}

.yesno-switch.text-switch {
  width: 62px;
  min-width: 62px;
}

.yesno-switch.text-switch .text-swtch-data .left,
.yesno-switch.text-switch .text-swtch-data .right {
  width: 25px;
}

.yesno-switch.text-switch .text-switch-label .text-swtch-data {
  left: -26px;
}

.yesno-switch.text-switch
  .text-switch-check:checked
  + .text-switch-label
  .text-swtch-data {
  left: 8px;
}

.yesno-switch.text-switch .text-switch-check:checked + .text-switch-label {
  background-color: #1c85e8;
}
.choose-img-box {
  display: flex;
  align-items: center;

  img {
    width: 80px;
    height: 55px;
  }
}
.concentrate-check {
  &:before {
    width: 48px;
    height: 48px;
    top: 50%;
    left: 50%;
    z-index: 6;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    transition: 0.4s cubic-bezier(0.55, 0, 0.55, 0.2);
    content: "";
  }
}
</style>
